import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const wrapper = (theme: Theme) => css`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: ${theme.ds5.spacing.gap.medium};
  white-space: nowrap;

  /* OneTrust pins its cookie button to the bottom-left of the viewport and Ada its chat
     launcher to the bottom-right, so once this drops onto its own row it centres between them. */
  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-basis: 100%;
  }
`;

export const flagIconWrapper = css`
  display: flex;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
`;

export const flagIcon = css`
  width: 100%;
  height: 100%;
`;
